// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import axiosInstance from "../../../config";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";
import MixedChart from "examples/Charts/MixedChart";
import BubbleChart from "examples/Charts/BubbleChart";
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";
import PieChart from "examples/Charts/PieChart";
import RadarChart from "examples/Charts/RadarChart";
import PolarChart from "examples/Charts/PolarChart";


// Data
// import defaultLineChartData from "layouts/pages/charts/data/defaultLineChartData";
// import gradientLineChartData from "layouts/pages/charts/data/gradientLineChartData";
// import verticalBarChartData from "layouts/pages/charts/data/verticalBarChartData";
// import horizontalBarChartData from "layouts/pages/charts/data/horizontalBarChartData";
// import mixedChartData from "layouts/pages/charts/data/mixedChartData";
// import bubbleChartData from "layouts/pages/charts/data/bubbleChartData";
// import defaultDoughnutChartData from "layouts/pages/charts/data/defaultDoughnutChartData";
// import pieChartData from "layouts/pages/charts/data/pieChartData";
// import radarChartData from "layouts/pages/charts/data/radarChartData";
// import polarChartData from "layouts/pages/charts/data/polarChartData";

import React, { useEffect, useState } from 'react';

function AnalyticCharts() {
  const [charts, setCharts] = useState([
  ]);

  const deleteChart = async (id) => {
    setCharts(charts.filter(chart => chart._id !== id));
  };

  const renderChart = (chart) => {
    switch (chart.type) {
      case 'defaultLine':
        return <DefaultLineChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'gradientLine':
        return <GradientLineChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'verticalBar':
        return <VerticalBarChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'horizontalBar':
        return <HorizontalBarChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'mixed':
        return <MixedChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'bubble':
        return <BubbleChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'doughnut':
        return <DefaultDoughnutChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'pie':
        return <PieChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'radar':
        return <RadarChart title={chart.title} description={chart.description} chart={chart.data} />;
      case 'polar':
        return <PolarChart title={chart.title} description={chart.description} chart={chart.data} />;
      default:
        return <MDTypography variant="h6">{chart.description}</MDTypography>
    }
  };

  const [prompt, setPrompt] = useState('Identify the most commonly used materials in Michael Kors bags and categorize them by primary material.');
  const handleSubmit = async () => {
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}/petopedia/pandesco`, {
        question: prompt
      });

      console.log('Response:', response.data);
      let answer = response.data.answer
      if(answer) {
        setCharts([...charts, answer]);
      }
    } catch (error) {
      console.error('Error submitting prompt:', error);
    }
  };

 return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}

      <MDBox mb={12}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={8}>
              <MDTypography variant="h6">Prompt</MDTypography>
              <textarea rows="5" style={{ width: '100%' }}
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
            
              ></textarea>
            </Grid>
            <Grid item xs={12} md={4}>
              <button onClick={handleSubmit} style={{ marginTop: '24px' }}>Submit</button>
            </Grid>
          </Grid>
      </MDBox>

      <MDBox my={3}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} sx={{ lineHeight: 0 }}>
              <MDTypography variant="h5">Analytical Charts</MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mb={6}>
          <Grid container spacing={3}>
            {charts.map(chart => (
              <Grid item xs={12} md={6} key={chart._id}>
                {renderChart(chart)}
                <button onClick={() => deleteChart(chart._id)}>Delete</button>
              </Grid>
            ))}
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default AnalyticCharts;